// @flow

import React, { PureComponent } from 'react';

import { getMonthName } from 'utils/dateUtils';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';

type EventFiltersOptionType = { label: string, value: string }

type Props = {
  filtersOptions: EventFiltersOptionType[],
  currentMonth: Date,
  selectedFilter: string,
  onMonthChange: (value: string) => void,
  onFilterClick: (value: string) => void,
}

export default class EventListNavbar extends PureComponent<Props> {
  handleClickFilter = (value: string) => {
    const { onFilterClick } = this.props;

    onFilterClick(value);
  };

  renderNavbarLinks = () => {
    const { filtersOptions, selectedFilter } = this.props;

    return filtersOptions.map<any>(({ label, value }) => {
      const className = (selectedFilter === value && 'is-active' ) || '';

      return (
          <li
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
            role='button'
            tabIndex={0}
            key={label}
            onClick={() => this.handleClickFilter(value)}>
            {/* eslint-disable-next-line */}
            <a className={className}>{label}</a>
          </li>
        );
    });
  };

  getLastMonthFromCurrent = (currentMonth: Date) => {
    const lastMonth = new Date(currentMonth);

    lastMonth.setDate(1);
    lastMonth.setMonth(lastMonth.getMonth() - 1);

    return lastMonth;
  };

  getNextMonthFromCurrent = (currentMonth: Date) => {
    const nextMonth = new Date(currentMonth);

    nextMonth.setDate(1);
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    return nextMonth;
  };


  getMonthsAsOptions = (baseMonth: Date): Array<{ value: string, label: string }> => {
    const previousMonths = [];
    const nextMonths = [];
    let currentMonth = baseMonth;

    for (let i = 0; i < 5; i++) {
      currentMonth = this.getLastMonthFromCurrent(currentMonth);
      previousMonths.push(currentMonth);
    }

    currentMonth = baseMonth;

    for (let i = 0; i < 5; i++) {
      currentMonth = this.getNextMonthFromCurrent(currentMonth);
      nextMonths.push(currentMonth);
    }

    return [...previousMonths.reverse(), baseMonth, ...nextMonths].map(month => ({
      value: month.toString(),
      label: `${getMonthName(month.getMonth())} ${month.getFullYear()}`
    }));
  };

  render() {
    const { currentMonth, onMonthChange } = this.props;

    return (
      <div className='events__filter'>
        <nav className='navbar'>
          <ul className='navbar__links'>
            {this.renderNavbarLinks()}
          </ul>
        </nav>
        <DropdownRadioInput
          label={`${getMonthName(currentMonth.getMonth())} ${currentMonth.getFullYear()}`}
          counter={0}
          id="Septembre 2018"
          isShadow
          labelIcon="icon-calendar"
          options={this.getMonthsAsOptions(currentMonth)}
          inputChanged={(value) => onMonthChange(value)}
          dropdownStyle={{ width: 220 }}
          title
          titleUpperCase
        />
      </div>
    );
  }
}
